module.exports = __webpack_public_path__ + "img/noprizePicture.49c1d674.png";